module.exports = __webpack_public_path__ + "static/media/xIcon.29cbe743.png";